var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "time-ago f-s-10" }, [
    _vm._v(_vm._s(_vm.prefixText) + " " + _vm._s(_vm.timeAgoText))
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }